import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDidUpdateEffect } from '../../hooks/useDidUpdateEffect';
import { dlItemsViewListEvent } from '../../events/dl.Items.viewList.event';
import { templateSuffix } from '../configs';
import { useDynamicConfigs } from '../hooks/useDynamicConfigs';
export const DLCollectionData = () => {
    const { defaultFilters } = useDynamicConfigs();
    const { hierarchyObjects, collection } = useDynamicConfigs();
    const { handle } = useParams();
    useDidUpdateEffect(() => {
        const obj = hierarchyObjects?.[handle ?? ''];
        if (obj === undefined)
            return;
        window.dataLayer.push({
            collection: {
                id: obj.id,
                name: obj.fullName,
                path: `/collections/${obj.handle}`
            },
            content: {
                handle: obj.handle
            }
        });
    }, [hierarchyObjects]);
    useEffect(() => {
        const obj = hierarchyObjects?.[handle ?? ''];
        dlItemsViewListEvent([{
                name: obj?.fullName ?? collection?.title ?? 'Search',
                path: obj?.facetValue,
                type: templateSuffix,
                filter: defaultFilters
            }]);
    }, [hierarchyObjects]);
    return null;
};
